import getEnabledItems from '@lyearn/core/utils/array/getEnabledItems';
import LearnerGroupsWidget from '@/modules/learner/views/LearnerProfile/components/LearnerGroupsWidget';
import { LearnerHierarchyWidget } from '@/modules/learner/views/LearnerProfile/components/LearnerHierarchyWidget';
import LearnerInfoWidget from '@/modules/learner/views/LearnerProfile/components/LearnerInfoWidget';
import LearnerTagsWidget from '@/modules/learner/views/LearnerProfile/components/LearnerTagsWidget';
import { LearnerProfileDetailsFragment } from '@/modules/learner/views/LearnerProfile/graphql/fragments/generated/LearnerProfileDetails';
import { UserStatusEnum } from '@/types/schema';

export const getLearnerProfileWidgets = (
  learner: LearnerProfileDetailsFragment,
  isAdmin: boolean,
) =>
  getEnabledItems([
    {
      key: 'learner-info',
      Component: LearnerInfoWidget,
      enabled: true,
    },
    {
      key: 'learner-hierarchy',
      Component: LearnerHierarchyWidget,
      enabled: true,
    },
    {
      key: 'learner-tags',
      Component: LearnerTagsWidget,
      enabled: isAdmin,
    },
    {
      key: 'learner-groups',
      Component: LearnerGroupsWidget,
      enabled: Boolean(learner.status === UserStatusEnum.Active) && isAdmin,
    },
  ]);
